export const getBarHeight = (
  value: number,
  reference: number,
  maxBarHeight: number
) => {
  if (reference === 0) {
    return 0;
  }
  const ratio = value / reference;
  const height = value > reference ? maxBarHeight : ratio * maxBarHeight;
  return height;
};
